module.exports = __webpack_public_path__ + "static/Banner_Health_logo-b5491445c8d0fafb06143ef539baba79.png";